import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCrown, FiShield } = FiIcons;

const Roster = () => {
  const leadership = [
    {
      name: "Juny",
      role: "Guild Leader",
      icon: FiCrown,
      gradient: "from-yellow-500 to-orange-500",
      bgGradient: "from-yellow-900/80 to-orange-900/80",
      borderColor: "border-yellow-500/50"
    },
    {
      name: "Junn",
      role: "Vice Leader",
      icon: FiShield,
      gradient: "from-red-500 to-purple-500",
      bgGradient: "from-red-900/80 to-purple-900/80",
      borderColor: "border-red-500/50"
    },
    {
      name: "Button",
      role: "Vice Leader",
      icon: FiShield,
      gradient: "from-emerald-500 to-blue-500",
      bgGradient: "from-emerald-900/80 to-blue-900/80",
      borderColor: "border-emerald-500/50"
    },
    {
      name: "Merik",
      role: "Vice Leader",
      icon: FiShield,
      gradient: "from-purple-500 to-pink-500",
      bgGradient: "from-purple-900/80 to-pink-900/80",
      borderColor: "border-purple-500/50"
    },
    {
      name: "Shrezy",
      role: "Vice Leader",
      icon: FiShield,
      gradient: "from-blue-500 to-cyan-500",
      bgGradient: "from-blue-900/80 to-cyan-900/80",
      borderColor: "border-blue-500/50"
    },
    {
      name: "Elesya",
      role: "Vice Leader",
      icon: FiShield,
      gradient: "from-pink-500 to-rose-500",
      bgGradient: "from-pink-900/80 to-rose-900/80",
      borderColor: "border-pink-500/50"
    }
  ];

  return (
    <section id="roster" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-purple-900/50 via-red-900/50 to-blue-900/50"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-red-400" style={{ fontFamily: 'fantasy, serif' }}>
            Guild Leadership
          </h2>
          <p className="text-white text-xl max-w-2xl mx-auto">
            Meet the legendary leaders who guide Crimson Guild to victory
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {leadership.map((leader, index) => (
            <motion.div
              key={leader.name}
              className={`bg-gradient-to-br ${leader.bgGradient} p-6 rounded-2xl shadow-2xl border-2 ${leader.borderColor} backdrop-blur-sm relative overflow-hidden group`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -5 }}
            >
              {/* Decorative corner elements */}
              <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-white/20 to-transparent rounded-br-full"></div>
              <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-white/20 to-transparent rounded-tl-full"></div>
              
              {/* Glow effect */}
              <div className={`absolute inset-0 bg-gradient-to-r ${leader.gradient} opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-2xl`}></div>
              
              <div className="relative z-10 text-center">
                <div className={`w-20 h-20 mx-auto mb-4 bg-gradient-to-br ${leader.gradient} rounded-full flex items-center justify-center shadow-lg shadow-black/50`}>
                  <SafeIcon icon={leader.icon} className="text-3xl text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-2">{leader.name}</h3>
                <p className={`text-transparent bg-clip-text bg-gradient-to-r ${leader.gradient} font-semibold text-lg`}>
                  {leader.role}
                </p>
                
                {/* Decorative border */}
                <div className={`mt-4 h-1 w-16 mx-auto bg-gradient-to-r ${leader.gradient} rounded-full`}></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roster;